
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcitas3jr0x } from '../../api/citas3jr0x.api'
import {createsuscripcionop8hb } from '../../api/suscripcionop8hb.api'

import './homeejie4.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Phomeejie4 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690100788e5aed52dc82c16f" >

      <div id="iw4j" className="">
      
      <div id="i6ssn" className="">
      
      <div id="imeimh" className="">
      
      <div id="i3s7cf" className="">
      
      </div>
      
      <div id="i9wh0g" className="">
      
      </div>
      
      <div id="ipke9t" className="">
      
      </div>
      
      <div id="i60elk" className="">
      
      </div>
      
      <div id="iwc8zb" className="">
      
      <div id="i6ztzg" className="">
      
      <img
        className=""
        id="ia8bbi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3jt9qt.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="iwrtu"
          href="mailto:info@example.com"
        >
          
    <div id="i06b9" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      <div id="iamrom" className="">
      
      <img
        className=""
        id="iywkvr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanptg4.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i6ymq"
          href="tel:+21236547898"
        >
          
    <div id="ilrna" className="">
    <>+504 3334-8846</>
    </div>
    
        </a>
        
      <div id="ivz97" className="">
      
      <img
        className=""
        id="i8i7g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanna44.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="id9ue">
        <>Lunes - Viernes (08AM - 05PM)</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i58lg7" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i0zkbr" className="">
      
      <div id="i0fboh" className="">
      
        <a
          target=""
          className=""
          id="iytouh"
          href={`/`}
        >
          
      <img
        className=""
        id="idepm2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3p0ayf.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="i76z8x" className="">
      
        <a
          target=""
          className=""
          id="idlxcg"
          href={`/`}
        >
          
    <div id="i7imp2" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ix0zc7"
          href={`/nosotros`}
        >
          
    <div id="i2vzcj" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
        <LoftyDropdownComponent
          id="im0qqv"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ixwopc" className="gjs-dropdown-menu-trigger ">
<>ÚNETE</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ihz1li" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iojw0f"
          href={`/socio_motorista`}
        >
          
    <div id="id1tnc" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ibs9om"
          href={`/publicidad`}
        >
          
    <div id="ialxa1" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="ii4h1h"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i687zt" className="gjs-dropdown-menu-trigger ">
<>POLÍTICAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="i8aj9g" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iy44hw"
          href={`/terminos_politicas`}
        >
          
    <div id="ilmv8g" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ikc7sg"
          href={`/eliminar_cuenta`}
        >
          
    <div id="ik8exo" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iief0t"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="icx7l1" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ixlphb" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="ie11fh"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5wol3" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="imdl75"
          href="#"
        >
          
    <div id="idim8j" className="">
    <>NOTICIAS !PRONTO!</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className=""
          id="ianf7t"
          href={`/contactanos`}
        >
          
    <div id="i3870v" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i96vd"
          href="https://api.whatsapp.com/send/?phone=33348846&text&type=phone_number&app_absent=0"
        >
          
      <img
        className=""
        id="ikof4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanr6xa.png"
        alt="undefined"
      />
      
    <div id="iwe9i" className="">
    <>Via WhatsApp</>
    </div>
    
        </a>
        
      <img
        className=""
        id="ilg8m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3k9u97.png"
        alt="undefined"
      />
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
        <a
          target=""
          className=""
          id="ig7nal"
          href={`/`}
        >
          
    <div id="iy6gfp" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyad6d"
          href={`/nosotros`}
        >
          
    <div id="iyfcbh" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
        <LoftyDropdownComponent
          id="isoayi"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i536rc" className="gjs-dropdown-menu-trigger ">
<>UNETE
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifxvuy" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3hxau"
          href={`/socio_motorista`}
        >
          
    <div id="ip699g" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iufdal"
          href={`/publicidad`}
        >
          
    <div id="iaawbk" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iq0mnk"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iqbgg9" className="gjs-dropdown-menu-trigger ">
<>POLITICA
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwcix" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i61hhc"
          href={`/terminos_politicas`}
        >
          
    <div id="iw1wej" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i4v96p"
          href={`/eliminar_cuenta`}
        >
          
    <div id="i6rlr2" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iwiyle"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ip6o3a" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="i6eavm" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3szb9"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i84e89" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir7afk"
          href="#"
        >
          
    <div id="i0l31h" className="">
    <>NOTICIAS !PRONTO¡</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <li className="linkshref " id="">
        
      </li>
      
        <a
          target=""
          className=""
          id="i18rof"
          href={`/contactanos`}
        >
          
    <div id="im4pp5" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="izhsmq" className="swiper mySwiper ">
      
      <div id="is1c7u" className="swiper-wrapper ">
      
      <div id="ixsb0x" className="swiper-slide ">
      
      <div id="iz1xa1" className="">
      
      <div id="i7mqhg" className="">
      
      </div>
      
      <div
        id="i94aga"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div className="" id="igpbjy">
        <>¡Bienvenido a Dicip Go!</>
      </div>
      
      </div>
      
      <div
        id="iurelm"
        className=""
        data-aos="fade-left"
        data-aos-duration="200"
      >
      
      <div className="" id="id3oof">
        <>"Posicionate </>
      <span className="" id="i75r2c">
        <>Con Exito</>
      </span>
      
      <br className="" id="" />
      <>Dicip Go! </>
      </div>
      
      </div>
      
      <div
        id="ityj4n"
        className=""
        data-aos="fade-right"
        data-aos-duration="2000"
      >
      
      <div className="" id="ichxks">
        <>Si quieres posicionar tu marca y alcanzar nichos de mercado estratégicos, únete a nuestra plataforma Dicip Go y llega a mas clientes por medio de publicidad geolocalizada.</>
      </div>
      
      </div>
      
      <div
        id="i8pxej"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i5j2ah" className="">
      
        <a
          target=""
          className=""
          id="io5irs"
          href={`/socio_motorista`}
        >
          
    <div id="" className="">
    <>MAS INFORMACION</>
    </div>
    
      <img
        className=""
        id="if1sov"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="i8gz8d"
          href={`/contactanos`}
        >
          
    <div id="" className="">
    <>CONTACTANOS</>
    </div>
    
      <img
        className=""
        id="iu5jsh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao4kp8.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ij083u" className="swiper-slide ">
      
      <div id="ifd99y" className="">
      
      <div id="i01xz6" className="">
      
      </div>
      
      <div
        id="i2016r"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div className="" id="iotd07">
        <>¡Bienvenido a Dicip Go!</>
      </div>
      
      </div>
      
      <div
        id="ibd16t"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div className="" id="iur93j">
        <>Revive </>
      <span className="" id="iv6ezi">
        <>la Publicidad </>
      </span>
      <> Creativa</>
      </div>
      
      </div>
      
      <div
        id="iahp2x"
        className=""
        data-aos="fade-right"
        data-aos-duration="2000"
      >
      
      <div className="" id="if8wk1">
        <>Dicip Go es una aplicación innovadora que ofrece</>
      <br className="" id="" />
      <>                    publicidad cuantitativa para empresas y oportunidades de ingresos adicionales para conductores.</>
      <br className="" id="" />
      <>                    Utiliza el escaneo de códigos QR y la geolocalización para medir el éxito de las campañas</>
      <br className="" id="" />
      <>                    publicitarias y llegar a la audiencia objetivo de manera precisa. Es una herramienta poderosa para</>
      <br className="" id="" />
      <>                    empresas que buscan destacarse en el mercado y para conductores que desean monetizar sus viajes.</>
      </div>
      
      </div>
      
      <div
        id="iwcrki"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="irk2dx" className="">
      
        <a
          target=""
          className=""
          id="i9n0wl"
          href={`/socio_motorista`}
        >
          
    <div id="" className="">
    <>MAS INFORMACION</>
    </div>
    
      <img
        className=""
        id="icydmq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="ibxfmj"
          href={`/contactanos`}
        >
          
    <div id="" className="">
    <>CONTACTANOS</>
    </div>
    
      <img
        className=""
        id="iivrwf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao4kp8.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="" className="swiper-button-next ">
      
      </div>
      
      <div id="" className="swiper-button-prev ">
      
      </div>
      
      <div id="" className="swiper-pagination ">
      
      </div>
      
      </div>
      
      <div id="ivzb1" className="">
      
      <div id="izx98iy" className="">
      
        <a
          target=""
          className=""
          id="iqteqd"
          href="#"
        >
          
      <img
        className=""
        id="ih8agp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhar4q3t.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="iq9ywj" className="">
      
        <div className="" id="iu8pt">
          
      <div className="" id="iiqnv8">
        
    <div id="i2mj8j" className="booking-title ">
    <>Únete a nuestro Equipo: ¡Agenda tu Cita Ahora!</>
    </div>
    
      </div>
      
      <form
        id="i89kh"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcitas3jr0x({
						token: 'aasdas',
						ciudaddm0a3: e.target.ciudaddm0a3.value,
						nombrecompletohd3lm: e.target.nombrecompletohd3lm.value,
						telefonoidihyi: e.target.telefonoidihyi.value,
						emailnapbb: e.target.emailnapbb.value,
						fechaqo88o: e.target.fechaqo88o.value,
						horareunionbz2wp: e.target.horareunionbz2wp.value,
						tipovehiculomvnwp: e.target.tipovehiculomvnwp.value,
						experienciauberxo2aj: e.target.experienciauberxo2aj.value,
					});
					window.location.reload();
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i2f4q" className="">
      
      <label id="igi2j" className="">
      <>Ubicacion de Residencia</>
      </label>
      
      <br className="" id="" />
      
      <div id="icrrnm" className="">
      
      <input
        name="ciudaddm0a3"
        type="text"
        placeholder="Ciudad"
        className=""
        id="ic7me"
      />
      
      <img
        className=""
        id="i3g9le"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhpacsgo.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="if55h" className="">
      
      <label id="iewfa" className="">
      <>Nombre Completo</>
      </label>
      
      <br className="" id="" />
      
      <div id="iq04j1" className="">
      
      <input
        name="nombrecompletohd3lm"
        type="text"
        placeholder="Nombre y un apellido"
        className=""
        id="if2bp"
      />
      
      <img
        className=""
        id="idji3c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhpad1ri.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ir1bi" className="">
      
      <label id="it7ghh" className="">
      <>Celular</>
      </label>
      
      <br className="" id="" />
      
      <div id="irg0t5" className="">
      
      <input
        name="telefonoidihyi"
        type="text"
        placeholder="Numero pegado"
        className=""
        id="iaqh52"
      />
      
      <img
        className=""
        id="i15p7g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhpad98w.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="im14vp" className="">
      
      <label id="i9lb5i" className="">
      <>Email</>
      </label>
      
      <br className="" id="" />
      
      <div id="i8w1oh" className="">
      
      <input
        name="emailnapbb"
        type="text"
        placeholder="Correo electronico"
        className=""
        id="i9gk0j"
      />
      
      <img
        className=""
        id="idvneg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhpadgos.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="in2iq" className="">
      
      <label id="iswwhk" className="">
      <>Fecha de la Cita</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="fechaqo88o"
        type="date"
        placeholder=""
        className=""
        id="iv52u"
      />
      
      </div>
      
      <div id="i9wf74" className="">
      
      <label id="inmuft" className="">
      <>Hora de Reunion</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="horareunionbz2wp"
        type="time"
        placeholder="00:00 Hora"
        className=""
        id="iut303"
      />
      
      </div>
      
      <div id="ikpfc9" className="">
      
      <label id="igu3gh" className="">
      <>Tipo de Vehiculo</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="tipovehiculomvnwp"
          className=""
          id="i2dxrg"
        >
          <option value={`Isuzu`}>Isuzu</option>
<option value={`Chevrolet`}>Chevrolet</option>
<option value={`Nissan`}>Nissas</option>
<option value={`Ford`}>Ford</option>
<option value={`Otra`}>Otra Marca</option>

        </select>
        
      </div>
      
      <div id="io5aef" className="">
      
      <label id="ii8dod" className="">
      <>Experiencia en Uber o Taxis</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="experienciauberxo2aj"
          className=""
          id="i7wj3b"
        >
          <option value={`a1`}>1</option>
<option value={`a2`}>2</option>
<option value={`a3`}>3</option>
<option value={`a4`}>+4 años</option>

        </select>
        
      </div>
      
      <button
        type="submit"
        name=""
        id="ind3cq"
        className=""
        
      >
      
      <div id="il47fj" className="">
      <>Enviar</>
      </div>
      
      <img
        className=""
        id="icgfl3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      <div id="ij746" className="">
      
      <div id="ibgecj" className="">
      
      <div
        id="ixuqz7"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div id="imizws" className="">
      
      <div id="isuyp2" className="">
      
      <img
        className=""
        id="iiq2yh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhativ2s.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="inykp9">
        <>Servicio de </>
      <br className="" id="" />
      <>Alta Calidad</>
      </div>
      
      </div>
      
      <div id="i79beg" className="">
      
      <img
        className=""
        id="iqao0p"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3stwf4.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div
        id="i8qg4u"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div id="i92o9c" className="">
      
      <div className="" id="iw7wk1">
        
      <span className="site-title-tagline justify-content-start " id="i855yg">
        <>Publicidad creativa</>
      </span>
      
      <span className="" id="in80rk">
        
      </span>
      
      </div>
      
      <div className="" id="i14zde">
        <>¿Tienes experiencia como conductor de transporte? ¡Conoces nuestros beneficios!</>
      </div>
      
      <div className="" id="iu5c9g">
        
      <p className="about-text " id="ilntzt">
        <>"Súmate a nuestro equipo en Dicip Go e innovemos la forma de hacer publicidad."</>
      </p>
      
    <div id="ihl3eh" className="about-list-wrapper ">
    
    <div id="i8y5ui" className="about-list list-unstyled ">
    
    </div>
    
    </div>
    
      </div>
      
      <div id="i7xmmy" className="">
      
      <div id="ie5lly" className="">
      
      <img
        className=""
        id="iek3rs"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaoc2od.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ivp1ut">
        <>Obtén ingresos extras al mostrar publicidad.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i3wr99" className="">
      
      <div id="iqe2nj" className="">
      
      <img
        className=""
        id="ink6ua"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaoc2od.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iuat0a">
        <>Controla tu propio tiempo.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9uesh" className="">
      
      <div id="io3m1k" className="">
      
      <img
        className=""
        id="i4s0ww"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaoc2od.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ipkb2a">
        <>Recibe bonificaciones por referidos.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="iibnle" className="">
      
      <div id="ifccjb" className="">
      
      <img
        className=""
        id="iqdfbs"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaoc2od.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ip69yz">
        <>Únete a nuestras alianzas y aprovecha sus beneficios.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="irg7gs"
          href={`/contactanos`}
        >
          
    <div id="iymwja" className="">
    <>CONTACTANOS</>
    </div>
    
      <img
        className=""
        id="iehkcl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isljnf" className="">
      
      <div className="" id="i8szek">
        
      <span className="site-title-tagline " id="i1wvu1">
        <>Servicios extras</>
      </span>
      
      </div>
      
      <div className="" id="is7wye">
        
    <div id="i96rqi" className="site-title ">
    <>El mejor servicio premium de seguridad, ¡Gratis!</>
    </div>
    
    <div id="ixu96e" className="site-title ">
    
    <div id="i1900d" className="heading-divider ">
    
    </div>
    
    </div>
    
    <div id="iqr80q" className="site-title ">
    
    </div>
    
      </div>
      
      </div>
      
      <div id="igq2bs" className="">
      
      <div id="ixpom7" className="">
      
      <div id="i59oih" className="">
      
      <img
        className=""
        id="i3dmhn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3ufi2q.jpeg"
        alt="undefined"
      />
      
      <div id="ifxwgm" className="">
      
      <div className="" id="iwfcqo">
        <>Bloqueo automático</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i3vhvk">
        <>Con bloqueo automático por robo o extravío, garantizamos la seguridad permanente de tu información personal en todo momento.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9cx6v" className="">
      
      <img
        className=""
        id="ih9kio"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaopup3.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iocudw" className="">
      
      <div id="ifajir" className="">
      
      <img
        className=""
        id="ishj9f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3v1wlm.jpg"
        alt="undefined"
      />
      
      <div id="ihrcht" className="">
      
      <div className="" id="iy3u4y">
        <>Geolocalización 24/7</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iriojh">
        <>Nuestra geolocalización precisa 24/7 garantiza la seguridad de nuestros socios, y para los clientes, información vital garantizada en todo momento.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ioyw4f" className="">
      
      <img
        className=""
        id="ivb3s1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaorjnl.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="izoz3i" className="">
      
      <div id="i7nymo" className="">
      
      <img
        className=""
        id="iw37ks"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3v270y.jpg"
        alt="undefined"
      />
      
      <div id="inttqw" className="">
      
      <div className="" id="i4t3eo">
        <>Seguro por robo</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i4x6ev">
        <>Preocupados por nuestros socios, hemos implementado un seguro contra robos para garantizar la recuperación de sus dispositivos.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ipe74o" className="">
      
      <img
        className=""
        id="in4g93"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaoparf.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iqwiok" className="">
      
      <div className="" id="ij29tg">
        
      <span className="site-title-tagline " id="iab1ky">
        <>Paquetes</>
      </span>
      
      </div>
      
      <div className="" id="in4eph">
        
    <div id="iuau1r" className="site-title ">
    <>Planes diseñados a tu presupuesto</>
    </div>
    
    <div id="ie0ieh" className="site-title ">
    
    <div id="idk4na" className="heading-divider ">
    
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      <div id="ibiu6c" className="">
      
      <div id="ij6j1j" className="">
      
      <div id="id68xg" className="">
      
      <img
        className=""
        id="iytdow"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh55kjno.png"
        alt="undefined"
      />
      
      <div className="" id="icztkb">
        <>PLAN BASICO</>
      </div>
      
      <div id="ic71j7" className="">
      
      <div id="ixy70n" className="">
      
      </div>
      
      <div id="ixdlhv" className="">
      
      </div>
      
      <div id="ici1t8" className="">
      
      </div>
      
      </div>
      
      <div id="iw65x6" className="">
      
      <div id="iuf3nf" className="">
      
      <img
        className=""
        id="ih616z"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf3vz4.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i35344">
        
    <div id="iw4l3r" className="">
    
    <div id="ijap9j" className="">
    <> 6 anuncios + 2 cambios</>
    </div>
    
    <div id="ikaup6" className="">
    
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      <div id="idfgxl" className="">
      
      <div id="ibnlry" className="">
      
      <img
        className=""
        id="iss4e8"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf85hi.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9mrfy">
        
      <span className="" id="ihmaoz">
        <>20-30 segundos c/u</>
      </span>
      
      </div>
      
      </div>
      
      <div id="izzskx" className="">
      
      <div id="iq3b8z" className="">
      
      <img
        className=""
        id="ilx38t"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf96pz.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ixu58j">
        
      <span className="" id="ixlhp7">
        <>Geolocalización: 2 al mes y 1 cambio</>
      </span>
      
      </div>
      
      </div>
      
      <div id="is7h08" className="">
      
      <div id="i9n24i" className="">
      
      <img
        className=""
        id="imm17v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfa1rk.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i6nndb">
        
      <span className="" id="ixyg74">
        <> Estadísticas 2 por mes</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ik5n4y" className="">
      
      <div id="iljoss" className="">
      
      <img
        className=""
        id="irjvkk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfb10j.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iwvxba">
        
      <span className="" id="i2zz7r">
        <>Priorizar hora pico</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="i8lrrg"
          href="#"
        >
          
    <div id="i19eqv" className="">
    <>PARA MAS INFORMACION</>
    </div>
    
      <img
        className=""
        id="ikuek8h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="i85w68" className="">
      
      <div id="iapjgj" className="">
      
      <img
        className=""
        id="i9zon8"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh55q23j.png"
        alt="undefined"
      />
      
      <div className="" id="i6yret">
        <>PLAN PREMIUM</>
      </div>
      
      <div id="ivhkrc" className="">
      
      <div id="inpaff" className="">
      
      </div>
      
      <div id="i6iq5u" className="">
      
      </div>
      
      <div id="iewz7k" className="">
      
      </div>
      
      </div>
      
      <div id="iln8re" className="">
      
      <div id="iixjki" className="">
      
      <img
        className=""
        id="irvoyr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf3vz4.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="itm7wy">
        
      <span className="" id="itrvv3">
        <>6 anuncios + 4 cambios</>
      </span>
      
      </div>
      
      </div>
      
      <div id="idv3jo" className="">
      
      <div id="iw2ep9" className="">
      
      <img
        className=""
        id="iq4gay"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf85hi.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i66smd">
        
      <span className="" id="ituzwp">
        <>20-30 segundos (A/R)</>
      </span>
      
      </div>
      
      </div>
      
      <div id="io9nv8" className="">
      
      <div id="i99ii8" className="">
      
      <img
        className=""
        id="ijg5db"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf96pz.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ipx756">
        
      <span className="" id="i53qrc">
        <> Geolocalización: 4 al mes y 4 cambio</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i3w4wy" className="">
      
      <div id="i1zhsg" className="">
      
      <img
        className=""
        id="ief263"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfa1rk.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ib09fj">
        
      <span className="" id="i4put3">
        <>Estadísticas 4 por mes</>
      </span>
      
      </div>
      
      </div>
      
      <div id="izuelj" className="">
      
      <div id="it8qlf" className="">
      
      <img
        className=""
        id="ig2nrt"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfb10j.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iyqznr">
        
      <span className="" id="i4hnao">
        <>Priorizar las 3 horas pico</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="iwyz8s"
          href="#"
        >
          
    <div id="igu0bj" className="">
    <>PARA MAS INFORMACION</>
    </div>
    
      <img
        className=""
        id="ien512"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="igrcig" className="">
      
      <div id="i9flc7" className="">
      
      <img
        className=""
        id="ion97h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh55q9ty.png"
        alt="undefined"
      />
      
      <div className="" id="iwinf2">
        <>PLAN MYPIME</>
      </div>
      
      <div id="ixxq27" className="">
      
      <div id="iuqqyj" className="">
      
      </div>
      
      <div id="i7488g" className="">
      
      </div>
      
      <div id="ifrghh" className="">
      
      </div>
      
      </div>
      
      <div id="i58yya" className="">
      
      <div id="ibycde" className="">
      
      <img
        className=""
        id="i9cdjv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf3vz4.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iwauyk">
        
      <span className="" id="imwvri">
        <> 3 anuncios + 1 cambios</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ii8nag" className="">
      
      <div id="iprlga" className="">
      
      <img
        className=""
        id="iipt0l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf85hi.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i385kc">
        
      <span className="" id="io94tp">
        <>20-30 segundos c/u</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ix3uht" className="">
      
      <div id="i4xm98" className="">
      
      <img
        className=""
        id="iwcqbu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcf96pz.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i6g3gb">
        
      <span className="" id="ibr316">
        <>Geolocalización: 1 al mes y 1 cambio</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ib5kda" className="">
      
      <div id="is942d" className="">
      
      <img
        className=""
        id="i96h4y"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfa1rk.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ie2gzh">
        
      <span className="" id="igioag">
        <> Estadísticas 1 por mes</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ir8ije" className="">
      
      <div id="ijkxma" className="">
      
      <img
        className=""
        id="i13f3h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhcfb10j.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="io89zo">
        
      <span className="" id="iujf52">
        <>Priorizar hora pico</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="iu0dcj"
          href="#"
        >
          
    <div id="i0npsm" className="">
    <>PARA MAS INFORMACION</>
    </div>
    
      <img
        className=""
        id="ijrjk7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="is5fgk" className="">
      
      <div id="i23zum" className="">
      
      <div id="i6upcs" className="">
      
      <div id="iz7em3" className="">
      
      <img
        className=""
        id="ikmiv9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaozquv.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iexumm">
        <>1000</>
      </div>
      
      <div className="" id="igyg28">
        <>Cupos Disponibles</>
      </div>
      
      </div>
      
      <div id="iy0y64" className="">
      
      <div id="ic7bda" className="">
      
      <img
        className=""
        id="ixj1in"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhap46t3.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ijp7i3">
        <>15000</>
      </div>
      
      <div className="" id="icv7zi">
        <>Clientes Mensuales</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="iwmqck" className="">
      
      <div id="i9o1ym" className="">
      
      <img
        className=""
        id="iyep4s"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaordgc.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i62kcn">
        <>700</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i3ziju">
        <>Nuestros Socios Motoristas</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="il3w03" className="">
      
      <div id="i7sqe1" className="">
      
      <img
        className=""
        id="if6uql"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaorjnl.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i7u8lp">
        <>10000</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i8w3m6">
        <>Viajes Mensuales</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i82m33" className="">
      
      <div id="io9b2k" className="">
      
      </div>
      
      <div id="idxak5" className="">
      
      <div className="" id="iy0tev">
        
      <span className="site-title-tagline " id="ih3s8l">
        <>Paquetes</>
      </span>
      
      </div>
      
      <div className="" id="ipvqwj">
        <>¿Como nos diferenciamos?</>
      </div>
      
      <div id="i9rcso" className="">
      
      </div>
      
      </div>
      
      <div id="iasby9" className="">
      
      <div id="i6dlvj" className="">
      
      <div id="ixzs9y" className="">
      
      <img
        className=""
        id="ia51lq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaor723.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ip0r1f">
        
    <div id="ibkzhn" className="">
    <>Innovación</>
      <br className="" id="" />
      
    </div>
    
      </div>
      
      <div className="" id="i15xyy">
        <>Transformamos la publicidad en transporte urbano, maximizando su impacto.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="idot92" className="">
      
      <div id="iohma7" className="">
      
      <img
        className=""
        id="ifjv3i"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaozig8.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ipel5p">
        
    <div id="i0czc1" className="">
    <>Digitalización Impactante</>
      <br className="" id="" />
      
    </div>
    
      </div>
      
      <div className="" id="ihqwnw">
        <>Transmitimos tus ideas con eficacia y rapidez transformando la manera de hacer publicidad.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="in7nhv" className="">
      
      <div id="iv4far" className="">
      
      <img
        className=""
        id="ibwi78"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhap916p.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="irt8iw">
        
    <div id="ix6khl" className="">
    <>Geolocalización</>
      <br className="" id="" />
      
    </div>
    
      </div>
      
      <div className="" id="i76hzd">
        <>Impulsa tus ventas con precisión en ubicaciones específicas.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i36jwg" className="">
      
      <div id="i3w1jt" className="">
      
      <img
        className=""
        id="ioof4h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhap8by8.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iozmwl">
        
    <div id="ier0vj" className="">
    <>Publicidad 24/7</>
      <br className="" id="" />
      
    </div>
    
      </div>
      
      <div className="" id="i9rm1h">
        <>Promoción constante para una visibilidad continua y efectiva.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iy3png" className="">
      
      </div>
      
      </div>
      
      <div id="iem077" className="">
      
      <div className="" id="iih5r5">
        
      <span className="site-title-tagline " id="iumbx1">
        <>Paquetes</>
      </span>
      
      </div>
      
      <div className="" id="i51nqm">
        <>Conexiones que Construyen</>
      </div>
      
      </div>
      
      <div id="iazt7v" className="">
      
      <div id="iaigkq" className="">
      
      <div id="inxjjg" className="">
      
      <img
        className=""
        id="im5x2y"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5bb5wh.jpeg"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="inimri">
        <>Innovación sin límites y soluciones sin ingual.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="itpkbtd" className="">
      
      <div id="iistebp" className="">
      
      <img
        className=""
        id="iwuzhyg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5bgirv.jpeg"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i8spk47">
        <>Uniendo sueños y creando realidades.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i37wl0f" className="">
      
      <div id="i16v08m" className="">
      
      <img
        className=""
        id="ivm3rbp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5bhjah.jpeg"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iytziaz">
        <>Pasión por la excelencia y con el éxito.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i7757mr" className="">
      
      <div id="ic338z5" className="">
      
      <img
        className=""
        id="ik71vas"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5bhv42.jpeg"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="irkpeu6">
        <>Cada desafío es una oportunidad para brillar.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i33p7e" className="">
      
      <div id="ip97oq" className="">
      
      </div>
      
      <div id="i4m9i2" className="">
      
      <div className="" id="img5vd">
        
      <span className="site-title-tagline text-white justify-content-start " id="i34ukd">
        <>Por qué elegirnos</>
      </span>
      
      </div>
      
      <div className="" id="iddf3o">
        <>Nos dedicamos a proporcionar un servicio de calidad.</>
      </div>
      
      <div className="" id="i37det">
        <>En Dicip Go revolucionamos la publicidad con geolocalización precisa y códigos QR. Proporcionamos estadísticas detalladas de reproducción de videos para optimizar campañas y llevar la publicidad a otra dimensiones.</>
      </div>
      
      <div id="ista1c" className="">
      
      <img
        className=""
        id="ifibt3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5cupij.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i6zowx" className="">
      
      <div id="iahgvu" className="">
      
      <div id="isb7cm" className="">
      
      <div id="ifssrj" className="">
      
      <img
        className=""
        id="i0pwuc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhap8pq6.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ij46i1" className="">
      
      <div id="iox27z" className="">
      
      <div className="" id="iaxmdq">
        <>Escaneó vía código QR</>
      </div>
      
      <div id="i0s4yk" className="">
      
      <img
        className=""
        id="ivg2bh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhceo23z.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="iqjl5p">
        <>El código QR, al ser escaneado, desbloquea descuentos adicionales en las promociones de cada producto, incentivando su uso y se dará el total de cuantas veces fue escaneado.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ifks2f" className="">
      
      <div id="ivbgvs" className="">
      
      <div id="ifx7po" className="">
      
      <img
        className=""
        id="icyu5x"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhape8zm.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i7387u" className="">
      
      <div id="ib4v26" className="">
      
      <div className="" id="i8u6j8">
        <>Geolocalización publicitaria</>
      </div>
      
      <div id="ijsbmf" className="">
      
      <img
        className=""
        id="ilk4lg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhceo7yq.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="itjvex">
        <>La geolocalización activa anuncios de empresas cercanas cuando el dispositivo pasa por un área con Dicip Go, mejorando la relevancia y efectividad de la publicidad local.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="it6gib" className="">
      
      <div id="i8cs37" className="">
      
      <div id="i9b9y7" className="">
      
      <img
        className=""
        id="ivatih"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhape1h0.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i9iirb" className="">
      
      <div id="imqnva" className="">
      
      <div className="" id="ih4bgc">
        <>Total de reproducciones</>
      </div>
      
      <div id="iupjdi" className="">
      
      <img
        className=""
        id="ia85e1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhceqczk.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="idiaph">
        
      <span className="" id="ivq3dx">
        <>Un porcentaje de todas las reproducciones de videos se calcula diaria, semanal y mensualmente, proporcionando una visión detallada del rendimiento de la campaña publicitaria.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iqyjhz" className="">
      
      <div id="ioo5vd" className="">
      
      <div id="izx1nj" className="">
      
      <div className="" id="iszoe5">
        
      <span className="" id="ie66nv">
        <>Dicp Go APP</>
      </span>
      
      </div>
      
      <div className="" id="ikgno5">
        <>¡Descarga nuestra App de Dicip Go gratutiamente!</>
      </div>
      
      <div className="" id="iiienk">
        <>"Dicip Go app exclusiva para conductores y optimiza tu experiencia en la carretera."</>
      <br className="" id="" />
      
      </div>
      
      <div id="ibb2t1" className="">
      
        <a
          target=""
          className=""
          id="ibyp4i"
          href="#"
        >
          
      <img
        className=""
        id="ih63w4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaph9qf.png"
        alt="undefined"
      />
      
    <div id="iq5l9f" className="">
    <>Disponible en Google Play</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i8swv3"
          href="#"
        >
          
      <img
        className=""
        id="i3paw9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhaphgbn.png"
        alt="undefined"
      />
      
    <div id="i4u6gl" className="">
    <>Pronto en App Store</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="iq1hxl" className="">
      
      <img
        className=""
        id="io67mf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5dkcxz.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2wkyy" className="">
      
      <div id="idtdzs" className="">
      
      </div>
      
      <div id="ili81h" className="">
      
      <div id="in8v1v" className="">
      
      <img
        className=""
        id="ih7oge"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5eabfn.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iabbo4">
        <>"Dicip Go, uniendo sueños y creando realidades."</>
      </div>
      
      <div id="i0aklm" className="">
      
      <div id="iiao7j" className="">
      
      <img
        className=""
        id="ihkvgk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapqszf.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i498ll"
          href="tel:+21236547898"
        >
          
    <div id="igphxl" className="">
    <>+(504)3334-8846</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iq49kk" className="">
      
      <div id="iv4iez" className="">
      
      <img
        className=""
        id="in61um"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapot9t.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="idnp2s">
        <>Tegucigalpa, Honduras</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9jhal" className="">
      
      <div id="ijhd05" className="">
      
      <img
        className=""
        id="i3rkkd"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapr4sr.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="ikoyxp"
          href="mailto:info@example.com"
        >
          
    <div id="id135y" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="itfo5z" className="">
      
      <div className="" id="ig6pu9">
        <>Links Web</>
      <br className="" id="" />
      
      </div>
      
      <div id="igw4ca" className="">
      
      <div id="igbbew" className="">
      
      </div>
      
      <div id="i7jg5x" className="">
      
      </div>
      
      <div id="i0cs3j" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i9jpdk"
        name="">
        
        <a
          target=""
          className=""
          id="ietl9z"
          href={`/`}
        >
          
    <div id="izfsug" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqjy9k"
          href={`/nosotros`}
        >
          
    <div id="idaplq" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iva6x9"
          href={`/socio_motorista`}
        >
          
    <div id="if5gpc" className="">
    <>Socios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv6xlh"
          href={`/publicidad`}
        >
          
    <div id="i9ee1g" className="">
    <>Publicidad</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="i0hajc" className="">
      
      <div className="" id="i1ry5b">
        <>Links Informativos</>
      <br className="" id="" />
      
      </div>
      
      <div id="indb5tt" className="">
      
      <div id="ijw2nr" className="">
      
      </div>
      
      <div id="i98yzz" className="">
      
      </div>
      
      <div id="ic6wg8w" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i0xug0v"
        name="">
        
        <a
          target=""
          className=""
          id="iglsjel"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5ifst9" className="">
    <>Preguntas frecuentes</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqur2hg"
          href="#"
        >
          
    <div id="il6qymo" className="">
    <>Noticias</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i06brkc"
          href={`/contactanos`}
        >
          
    <div id="i52b9sc" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i9jwj9h"
          href={`/eliminar_cuenta`}
        >
          
    <div id="igvbgf6" className="">
    <>Eliminación de Cuentas</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="ibyhr7" className="">
      
      <div className="" id="i2gad2j">
        <>¡Suscríbete!</>
      <br className="" id="" />
      
      </div>
      
      <div id="iqf20lh" className="">
      
      <div id="iouqnbe" className="">
      
      </div>
      
      <div id="i0t7w7h" className="">
      
      </div>
      
      <div id="ijggbbk" className="">
      
      </div>
      
      </div>
      
      <div className="" id="ix1u5ym">
        <>Compártenos tu correo electrónico para que permanezcas informado sobre los últimos avances de Dicip Go.</>
      <br className="" id="" />
      
      </div>
      
        <div className="" id="i2lei25">
          
      <form
        id="iu2vtff"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createsuscripcionop8hb({
						token: 'aasdas',
						emailad4px: e.target.emailad4px.value,
					});
					window.location.reload();
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i4vo85m" className="">
      
      <br className="" id="" />
      
      <input
        name="emailad4px"
        type="text"
        placeholder="Email."
        className=""
        id="igp0qsh"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="id33zr1"
        className=""
        
      >
      
      <div id="iuqrm78" className="">
      <>SUSCRIBETE</>
      </div>
      
      <img
        className=""
        id="iupuxgq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="ia6axz" className="">
      
      <div className="" id="ikx7mga">
        <>© Copyright 2025 Dicip Go All Rights Reserved. Created by Go Data Monkey</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Phomeejie4);
  